// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__ZgDjD","title":"AfterBackImages_title__1d2rM","images":"AfterBackImages_images__3cDJu"};